const TICKER_PIXELS_PER_SECOND = 48;

export const getTickerDuration = (distance) => {
  const safeDistance = Number(distance) || 0;
  if (safeDistance <= 0) return "1s";

  return `${(safeDistance / TICKER_PIXELS_PER_SECOND).toFixed(2)}s`;
};
